/* tslint:disable */
/* eslint-disable */
/**
 * All APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  FindListingsAv8Request,
  FindListingsAv8Response,
  FindMapListingsResponse,
  GetListingDetailsByMlsIdAv8Request,
  SearchParamsMap,
  SinglePropertyResponse,
  TerritorySuggestionsRequest,
  TerritorySuggestionsResponse,
  TerritoryWithPolygonResponse,
} from '../models/index';
import {
    FindListingsAv8RequestFromJSON,
    FindListingsAv8RequestToJSON,
    FindListingsAv8ResponseFromJSON,
    FindListingsAv8ResponseToJSON,
    FindMapListingsResponseFromJSON,
    FindMapListingsResponseToJSON,
    GetListingDetailsByMlsIdAv8RequestFromJSON,
    GetListingDetailsByMlsIdAv8RequestToJSON,
    SearchParamsMapFromJSON,
    SearchParamsMapToJSON,
    SinglePropertyResponseFromJSON,
    SinglePropertyResponseToJSON,
    TerritorySuggestionsRequestFromJSON,
    TerritorySuggestionsRequestToJSON,
    TerritorySuggestionsResponseFromJSON,
    TerritorySuggestionsResponseToJSON,
    TerritoryWithPolygonResponseFromJSON,
    TerritoryWithPolygonResponseToJSON,
} from '../models/index';

export interface WidgetsControllersSidekickFindListingsV3Request {
    findListingsAv8Request: FindListingsAv8Request;
}

export interface WidgetsControllersSidekickFindMapListingsRequest {
    searchParamsMap: SearchParamsMap;
}

export interface WidgetsControllersSidekickGetListingDetailsByMlsIdRequest {
    getListingDetailsByMlsIdAv8Request: GetListingDetailsByMlsIdAv8Request;
}

export interface WidgetsControllersSidekickTerritoryRequest {
    name: string;
    nameType?: WidgetsControllersSidekickTerritoryNameTypeEnum;
    city?: string;
    stateAbbreviated?: string;
    simplificationTolerance?: number;
}

export interface WidgetsControllersSidekickTerritorySuggestionsRequest {
    territorySuggestionsRequest: TerritorySuggestionsRequest;
}

/**
 * WidgetActionsApi - interface
 * 
 * @export
 * @interface WidgetActionsApiInterface
 */
export interface WidgetActionsApiInterface {
    /**
     * 
     * @param {FindListingsAv8Request} findListingsAv8Request 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WidgetActionsApiInterface
     */
    widgetsControllersSidekickFindListingsV3Raw(requestParameters: WidgetsControllersSidekickFindListingsV3Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FindListingsAv8Response>>;

    /**
     */
    widgetsControllersSidekickFindListingsV3(requestParameters: WidgetsControllersSidekickFindListingsV3Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FindListingsAv8Response>;

    /**
     * 
     * @param {SearchParamsMap} searchParamsMap 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WidgetActionsApiInterface
     */
    widgetsControllersSidekickFindMapListingsRaw(requestParameters: WidgetsControllersSidekickFindMapListingsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FindMapListingsResponse>>;

    /**
     */
    widgetsControllersSidekickFindMapListings(requestParameters: WidgetsControllersSidekickFindMapListingsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FindMapListingsResponse>;

    /**
     * 
     * @param {GetListingDetailsByMlsIdAv8Request} getListingDetailsByMlsIdAv8Request 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WidgetActionsApiInterface
     */
    widgetsControllersSidekickGetListingDetailsByMlsIdRaw(requestParameters: WidgetsControllersSidekickGetListingDetailsByMlsIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SinglePropertyResponse>>;

    /**
     */
    widgetsControllersSidekickGetListingDetailsByMlsId(requestParameters: WidgetsControllersSidekickGetListingDetailsByMlsIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SinglePropertyResponse>;

    /**
     * 
     * @param {string} name Territory name to search for
     * @param {'street-and-number' | 'street' | 'neighborhood' | 'zip-code' | 'city' | 'county' | 'state-abbreviated' | 'district' | 'sub-district' | 'school-district'} [nameType] Type of territory
     * @param {string} [city] City context for the territory
     * @param {string} [stateAbbreviated] State abbreviation context for the territory
     * @param {number} [simplificationTolerance] Polygon simplification level (1-100, higher &#x3D; more simplified)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WidgetActionsApiInterface
     */
    widgetsControllersSidekickTerritoryRaw(requestParameters: WidgetsControllersSidekickTerritoryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TerritoryWithPolygonResponse>>;

    /**
     */
    widgetsControllersSidekickTerritory(requestParameters: WidgetsControllersSidekickTerritoryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TerritoryWithPolygonResponse>;

    /**
     * 
     * @param {TerritorySuggestionsRequest} territorySuggestionsRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WidgetActionsApiInterface
     */
    widgetsControllersSidekickTerritorySuggestionsRaw(requestParameters: WidgetsControllersSidekickTerritorySuggestionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TerritorySuggestionsResponse>>;

    /**
     */
    widgetsControllersSidekickTerritorySuggestions(requestParameters: WidgetsControllersSidekickTerritorySuggestionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TerritorySuggestionsResponse>;

}

/**
 * 
 */
export class WidgetActionsApi extends runtime.BaseAPI implements WidgetActionsApiInterface {

    /**
     */
    async widgetsControllersSidekickFindListingsV3Raw(requestParameters: WidgetsControllersSidekickFindListingsV3Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FindListingsAv8Response>> {
        if (requestParameters['findListingsAv8Request'] == null) {
            throw new runtime.RequiredError(
                'findListingsAv8Request',
                'Required parameter "findListingsAv8Request" was null or undefined when calling widgetsControllersSidekickFindListingsV3().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["email", "openid"]);
        }


        let urlPath = `/actions/widgets/sidekick/find-listings-v3`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: FindListingsAv8RequestToJSON(requestParameters['findListingsAv8Request']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FindListingsAv8ResponseFromJSON(jsonValue));
    }

    /**
     */
    async widgetsControllersSidekickFindListingsV3(requestParameters: WidgetsControllersSidekickFindListingsV3Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FindListingsAv8Response> {
        const response = await this.widgetsControllersSidekickFindListingsV3Raw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async widgetsControllersSidekickFindMapListingsRaw(requestParameters: WidgetsControllersSidekickFindMapListingsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FindMapListingsResponse>> {
        if (requestParameters['searchParamsMap'] == null) {
            throw new runtime.RequiredError(
                'searchParamsMap',
                'Required parameter "searchParamsMap" was null or undefined when calling widgetsControllersSidekickFindMapListings().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["email", "openid"]);
        }


        let urlPath = `/actions/widgets/sidekick/find-map-listings`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SearchParamsMapToJSON(requestParameters['searchParamsMap']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FindMapListingsResponseFromJSON(jsonValue));
    }

    /**
     */
    async widgetsControllersSidekickFindMapListings(requestParameters: WidgetsControllersSidekickFindMapListingsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FindMapListingsResponse> {
        const response = await this.widgetsControllersSidekickFindMapListingsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async widgetsControllersSidekickGetListingDetailsByMlsIdRaw(requestParameters: WidgetsControllersSidekickGetListingDetailsByMlsIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SinglePropertyResponse>> {
        if (requestParameters['getListingDetailsByMlsIdAv8Request'] == null) {
            throw new runtime.RequiredError(
                'getListingDetailsByMlsIdAv8Request',
                'Required parameter "getListingDetailsByMlsIdAv8Request" was null or undefined when calling widgetsControllersSidekickGetListingDetailsByMlsId().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["email", "openid"]);
        }


        let urlPath = `/actions/widgets/sidekick/get-listing-details-by-mls-id`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: GetListingDetailsByMlsIdAv8RequestToJSON(requestParameters['getListingDetailsByMlsIdAv8Request']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SinglePropertyResponseFromJSON(jsonValue));
    }

    /**
     */
    async widgetsControllersSidekickGetListingDetailsByMlsId(requestParameters: WidgetsControllersSidekickGetListingDetailsByMlsIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SinglePropertyResponse> {
        const response = await this.widgetsControllersSidekickGetListingDetailsByMlsIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async widgetsControllersSidekickTerritoryRaw(requestParameters: WidgetsControllersSidekickTerritoryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TerritoryWithPolygonResponse>> {
        if (requestParameters['name'] == null) {
            throw new runtime.RequiredError(
                'name',
                'Required parameter "name" was null or undefined when calling widgetsControllersSidekickTerritory().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['name'] != null) {
            queryParameters['name'] = requestParameters['name'];
        }

        if (requestParameters['nameType'] != null) {
            queryParameters['nameType'] = requestParameters['nameType'];
        }

        if (requestParameters['city'] != null) {
            queryParameters['city'] = requestParameters['city'];
        }

        if (requestParameters['stateAbbreviated'] != null) {
            queryParameters['stateAbbreviated'] = requestParameters['stateAbbreviated'];
        }

        if (requestParameters['simplificationTolerance'] != null) {
            queryParameters['simplificationTolerance'] = requestParameters['simplificationTolerance'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["email", "openid"]);
        }


        let urlPath = `/actions/widgets/sidekick/territory`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TerritoryWithPolygonResponseFromJSON(jsonValue));
    }

    /**
     */
    async widgetsControllersSidekickTerritory(requestParameters: WidgetsControllersSidekickTerritoryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TerritoryWithPolygonResponse> {
        const response = await this.widgetsControllersSidekickTerritoryRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async widgetsControllersSidekickTerritorySuggestionsRaw(requestParameters: WidgetsControllersSidekickTerritorySuggestionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TerritorySuggestionsResponse>> {
        if (requestParameters['territorySuggestionsRequest'] == null) {
            throw new runtime.RequiredError(
                'territorySuggestionsRequest',
                'Required parameter "territorySuggestionsRequest" was null or undefined when calling widgetsControllersSidekickTerritorySuggestions().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["email", "openid"]);
        }


        let urlPath = `/actions/widgets/sidekick/territory-suggestions`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: TerritorySuggestionsRequestToJSON(requestParameters['territorySuggestionsRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TerritorySuggestionsResponseFromJSON(jsonValue));
    }

    /**
     */
    async widgetsControllersSidekickTerritorySuggestions(requestParameters: WidgetsControllersSidekickTerritorySuggestionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TerritorySuggestionsResponse> {
        const response = await this.widgetsControllersSidekickTerritorySuggestionsRaw(requestParameters, initOverrides);
        return await response.value();
    }

}

/**
 * @export
 */
export const WidgetsControllersSidekickTerritoryNameTypeEnum = {
    StreetAndNumber: 'street-and-number',
    Street: 'street',
    Neighborhood: 'neighborhood',
    ZipCode: 'zip-code',
    City: 'city',
    County: 'county',
    StateAbbreviated: 'state-abbreviated',
    District: 'district',
    SubDistrict: 'sub-district',
    SchoolDistrict: 'school-district'
} as const;
export type WidgetsControllersSidekickTerritoryNameTypeEnum = typeof WidgetsControllersSidekickTerritoryNameTypeEnum[keyof typeof WidgetsControllersSidekickTerritoryNameTypeEnum];
